var footerData = {
    subtitle_1:"Created with React.js",
    subtitle_2:"Developed and Designed by Edouard Mignien",
}

exports.footerData = footerData